// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ENV } from "./env.enum";

export const environment = {
  environment: ENV.STAGE,
  production: false,
  persistUserSession: true,
  ClientUrl: 'https://stage-jobnet.trimor.com/',
  apiEndPoint: 'https://jobnet-api-stage.azurewebsites.net/',
  clientId: '9f32ab72-d90c-436d-a019-3b19dfddf2cb',
  tenantId: 'ee5d6ef2-372b-4831-b88d-b8ca7635926a',
  graphAPI: {
    resourceUri: 'https://graph.microsoft.com/v1.0/me',
    resourceScopes: ['user.read'],
  },
  JobScheduleAPI: {
    resourceScopes: [
      '9f32ab72-d90c-436d-a019-3b19dfddf2cb/.default offline_access openid',
    ],
  },
  msAzureConnection: {
    appService: 'jobnet-client-Stage',
    ftpsEndPoint: 'ftps://waws-prod-bn1-131.ftp.azurewebsites.windows.net/site/wwwroot',
    username: 'jobnet-client-Stage\$jobnet-client-Stage',
    password: 'y1fRB8Gx8sX3FXGw7f6zawe2nSMFPmvkTp3rf780xYRHuBnZBEF9R0dGrBjj'
  },
  jobScheduleRedirect: 'https://stage.trimor.com/foreman/admin/scheduler'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
